<template>
    <div
        class="footer-container my-auto w-100 main-area"
        style="height: 100px !important; box-shadow:none; background: #E7F6F6; border-radius:0px"
        >
        <div style="text-align:center; font-size: 14px; margin-bottom: 5px;">
            <p style="color: #3c3c3c;">
                求人情報やその他のお問合せ先　<a href="mailto:info@blm.co.jp">info@blm.co.jp</a>
            </p>
        </div>
        <div class="site-title-custom row full justify-content-center">
            <p>
                <a href="https://www.blm.co.jp/" target="_blank" style="color:#232323;text-decoration: underline;">© Bloom Inc.</a>
            </p>
            <p>
                <a href="https://www.blm.co.jp/privacy.html" target="_blank">
                    プライバシーポリシー
                </a>
            </p>
            <p>
                <a href="https://www.blm.co.jp/security.html" target="_blank">
                  情報セキュリティ基本方針
                </a>
            </p>  
        </div>
        <!-- <div class="mb-5" style="text-align:center">
            <a href="https://www.blm.co.jp/" target="_blank" style="color:#232323;text-decoration: underline;">© Bloom Inc.</a>
        </div> -->
    </div>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>
    .footer-container {
        position: relative;
        margin-top: auto;
        width: 100%;
    }
    .site-title-custom {
        padding-bottom: 0px !important;
    }
    a {
        color: #3c3c3c;
    }
    .full{
        gap:100px;
    }
   @media (max-width:550px){
    .full{
        gap:20px;
    }
    p {
        font-size: 12px;
    }
   }
</style>
